/*  ========================================================================
    # Sections - Contact Persons
    ========================================================================  */

import React, { useState } from 'react';
import useContactPersonsApi from '@/react/hooks/useContactPersonsApi';

const ContactPersons = ({
  headline,
  showAllContactPersons,
  selectedContactPersons,
  locations,
  industries,
  focuses,
  focusConsulting,
  focusIt,
  focusRechtsberatung,
  focusSteuerberatung,
  focusWirtschaftspruefung
}) => {
  const [locationParam, setLocationParam] = useState('');
  const [industryParam, setIndustryParam] = useState('');
  const [focusParam, setFocusParam] = useState('');
  const [subfocusParam, setSubfocusParam] = useState('');

  /**
   * Subfocus options based on focus param.
   */
  const subfocusOptions = {
    'consulting': focusConsulting || [],
    'it-beratung': focusIt || [],
    'rechtsberatung': focusRechtsberatung || [],
    'steuerberatung': focusSteuerberatung || [],
    'wirtschaftspruefung': focusWirtschaftspruefung || []
  };

  /**
   * Use Contact Persons REST API.
   */
  const { loading, contactPersons } = useContactPersonsApi({
    showAllContactPersons: showAllContactPersons,
    selectedContactPersons: selectedContactPersons,
    location: locationParam,
    industry: industryParam,
    focus: focusParam,
    subfocus: subfocusParam
  });

  return (
    <>
      {/* Header */}
      {showAllContactPersons || headline ? (
        <div className='s-contact-persons__header'>
          <div className='container'>
            {headline ? (
              <div className="s-contact-persons__headline" dangerouslySetInnerHTML={{ __html: headline }} />
            ) : null}
            {showAllContactPersons ? (
              <div className='s-contact-persons__filter'>
                {/* Location Dropdown */}
                <select className='s-contact-persons__filter-select' value={locationParam} onChange={event => setLocationParam(event.target.value)}>
                  <option value="">{window.ddpTranslations?.allLocations || "Alle Standorte"}</option>
                  {locations && locations.map(location => (
                    <option key={`location-${location.value}`} value={location.value}>{location.label}</option>
                  ))}
                </select>

                {/* Industry Dropdown */}
                <select className='s-contact-persons__filter-select' value={industryParam} onChange={event => setIndustryParam(event.target.value)}>
                  <option value="">{window.ddpTranslations?.allIndustries || "Alle Branchenschwerpunkte"}</option>
                  {industries && industries.map(industry => (
                    <option key={`industry-${industry.value}`} value={industry.value}>{industry.label}</option>
                  ))}
                </select>

                {/* Focus Dropdown */}
                <select className='s-contact-persons__filter-select' value={focusParam} onChange={event => setFocusParam(event.target.value)}>
                  <option value="">{window.ddpTranslations?.allFocuses || "Alle fachlichen Schwerpunkte"}</option>
                  {focuses && focuses.map(focus => (
                    <option key={`focus-${focus.value}`} value={focus.value}>{focus.label}</option>
                  ))}
                </select>

                {/* Subfocus Dropdown */}
                {focusParam && subfocusOptions[focusParam] ? (
                  <select
                    className='s-contact-persons__filter-select'
                    value={subfocusParam}
                    onChange={event => setSubfocusParam(event.target.value)}
                  >
                    <option value="">{window.ddpTranslations?.allSubfocuses || "Alle fachlichen Unterpunkte"}</option>
                    {subfocusOptions[focusParam].map(option => (
                      <option key={`${focusParam}-${option.value}`} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      ) : null}

      {/* Content */}
      <div className='s-contact-persons__content'>
        <div className='container'>
          <div className='row' style={{ gap: '50px 0' }}>
            {loading ? (
              <>
                {[...Array(3)].map((person, index) => (
                  <div key={`${index}-skeleton`} className='col-12 col-sm-6 col-lg-4'>
                    <div className='s-contact-persons__person-skeleton'>
                      <div />
                      <div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : null}
            {!loading && contactPersons.length > 0 ? (
              <>
                {contactPersons.map(person => (
                  <div key={person.id} className='col-12 col-sm-6 col-lg-4'>
                    <a className='s-contact-persons__person' href={person.link}>
                      <figure className='s-contact-persons__person-image'>
                        <img src={person.acf.image.sizes.large} alt={`${person.acf.name} ${person.acf.surname}`} />
                      </figure>
                      <div className='s-contact-persons__person-content'>
                        <h3>{person.acf.name} {person.acf.surname}</h3>
                        <p>{person.acf.position}</p>
                      </div>
                    </a>
                  </div>
                ))}
              </>
            ) : null}
            {!loading && contactPersons.length === 0 ? (
              <span style={{ fontSize: '32px', fontWeight: '700', textAlign: 'center' }}>
                {window.ddpTranslations?.noPersonsFound || "Keine Personen gefunden."}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPersons;
